import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, MapPin } from "lucide-react";
import { api } from "../lib/api";
import { PageHero, Chip, Empty } from "../components/ui-parts";
import { useI18n } from "../contexts/I18nContext";

export default function Courses() {
  const { t } = useI18n();
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/courses").then(r => setList(r.data)); }, []);
  const filtered = list.filter(c => (filter === "all" || (filter === "free" ? c.is_free : !c.is_free)) && (!q || c.name?.toLowerCase().includes(q.toLowerCase())));
  return (
    <div data-testid="courses-page">
      <PageHero badge="Learn" title="Sanskrit Courses" subtitle="Choose from free introductory camps or structured paid programmes for deeper study." />
      <section className="section">
        <div className="container-narrow">
          <div className="flex flex-wrap items-center gap-3 mb-8">
            <div className="flex gap-2">
              {["all", "free", "paid"].map(f => (
                <button key={f} onClick={() => setFilter(f)} data-testid={`filter-${f}`} className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${filter === f ? "bg-[var(--js-primary)] text-white" : "bg-white border border-[var(--js-border)] text-[var(--js-muted)] hover:border-[var(--js-primary)]"}`}>{f === "all" ? "All" : t(`common.${f}`)}</button>
              ))}
            </div>
            <div className="relative flex-1 max-w-sm">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--js-muted)]" />
              <input data-testid="course-search" value={q} onChange={e => setQ(e.target.value)} placeholder="Search courses…" className="w-full pl-10 pr-3 py-2 rounded-full border border-[var(--js-border)] bg-white text-sm" />
            </div>
          </div>
          {filtered.length === 0 ? <Empty title="No courses match" hint="Try clearing the filter or search." /> :
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {filtered.map(c => (
                <Link key={c.id} to={`/courses/${c.id}`} className="js-card p-6 block" data-testid={`course-${c.id}`}>
                  <div className="flex justify-between items-center mb-3">
                    <Chip variant={c.is_free ? "free" : "paid"}>{c.is_free ? t("common.free") : t("common.paid")}</Chip>
                    <span className="text-xs text-[var(--js-muted)]">{c.mode}</span>
                  </div>
                  <div className="font-heading text-xl text-[var(--js-primary)]">{c.name}</div>
                  <p className="text-sm text-[var(--js-muted)] mt-2 line-clamp-3">{c.description}</p>
                  <div className="flex items-center gap-3 mt-4 text-xs text-[var(--js-muted)]">
                    <span className="flex items-center gap-1"><MapPin size={12} /> {c.district}</span>
                    <span>· {c.duration}</span>
                    <span>· {c.level}</span>
                  </div>
                  {!c.is_free && c.fee && <div className="mt-3 text-sm font-semibold text-[var(--js-primary)]">₹ {c.fee}</div>}
                </Link>
              ))}
            </div>
          }
        </div>
      </section>
    </div>
  );
}
